import Typography from '@material-ui/core/Typography';
import {collapsedSidebarAction} from '../../actions';
import classNames from 'classnames';
import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import AppConfig from '../../config/AppConfig';
import NewUserBlock from './NewUserBlock';
import SidebarContent from './SidebarContent.tsx';

class Sidebar extends Component {
    UNSAFE_componentWillMount() {
        this.updateDimensions();
    }

    shouldComponentUpdate(nextProps) {
        const {enableSidebarBackgroundImage, selectedSidebarImage, isDarkSidenav, locale} = this.props;
        if (
            enableSidebarBackgroundImage !== nextProps.enableSidebarBackgroundImage ||
            selectedSidebarImage !== nextProps.selectedSidebarImage ||
            isDarkSidenav !== nextProps.isDarkSidenav ||
            locale
        ) {
            return true;
        } else {
            return false;
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {windowWidth} = this.state;
        const {collapsedSidebarAction} = this.props;
        if (nextProps.location !== this.props.location) {
            if (windowWidth <= 1199) {
                collapsedSidebarAction(false);
            }
        }
    }

    updateDimensions = () => {
        this.setState({windowWidth: window.innerWidth, windowHeight: window.innerHeight});
    };

    render() {
        const {enableSidebarBackgroundImage, selectedSidebarImage, isDarkSidenav} = this.props;
        return (
            <Fragment>
                <div
                    className={classNames('rct-sidebar', {'background-none': !enableSidebarBackgroundImage})}
                    style={{backgroundImage: enableSidebarBackgroundImage ? `url(${selectedSidebarImage})` : 'none'}}
                >
                    <div
                        className={classNames('rct-sidebar-content', {
                            'sidebar-overlay-dark': isDarkSidenav,
                            'sidebar-overlay-light': !isDarkSidenav,
                        })}
                    >
                        <div className="menu-header-shadow">
                            <div className="site-logo">
                                <Link to="/" className="logo-mini">
                                    <Typography className="temporary-sidebar-logo">{AppConfig.brandName[0]}</Typography>
                                </Link>
                                <Link to="/" className="logo-normal">
                                    <Typography className="temporary-sidebar-logo">{AppConfig.brandName.slice(1)}</Typography>
                                </Link>
                            </div>
                            <div className="rct-sidebar-wrap-profile">
                                <NewUserBlock/>
                            </div>
                        </div>
                        <div className="rct-sidebar-wrap">
                            <div className="sidebar-scroller">
                                <SidebarContent />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

// map state to props
const mapStateToProps = ({settings}) => {
    const {enableSidebarBackgroundImage, selectedSidebarImage, collapsedSidebar, isDarkSidenav, locale} = settings;
    return {enableSidebarBackgroundImage, selectedSidebarImage, collapsedSidebar, isDarkSidenav, locale};
};

export default withRouter(
    connect(mapStateToProps, {
        collapsedSidebarAction,
    })(Sidebar),
);
